// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b21M","inner":"styles_inner__LEMbh","right":"styles_right__2Mb-f","close":"styles_close__3a0hI","footer":"styles_footer__35-vN"};